import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Header from '../components/Header';
import HeroFR from '../components/fr/HeroFR';
import ProblemSolutionFR from '../components/fr/ProblemSolutionFR';
import ProcessFR from '../components/fr/ProcessFR';
import ProductShowcaseFR from '../components/fr/ProductShowcaseFR';
import ROICalculatorPricing from '../components/ROICalculatorPricing';
import FAQFR from '../components/fr/FAQFR';
import FooterFR from '../components/fr/FooterFR';

/**
 * French landing page for real estate agents.
 * Navbar: Tarifs, Portfolio, FAQ, Connexion, S'inscrire. No ROI Calculator.
 * Pricing in €. Unused credits valid 6 months (message in ROICalculatorPricing when locale=fr).
 */
const PageFR: React.FC = () => {
  const [activeProfileId, setActiveProfileId] = useState<'matterport-only' | 'matterport-drone'>('matterport-only');

  return (
    <motion.div
      className="min-h-screen bg-gradient-to-b from-white to-[#3C59B2]/10"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Header />
      <HeroFR variant="agents" />
      <ProblemSolutionFR variant="agents" activeProfileId={activeProfileId} onProfileChange={setActiveProfileId} />
      <ProcessFR variant="agents" />
      <ProductShowcaseFR variant="agents" activeProfileId={activeProfileId} />
      <ROICalculatorPricing showRoiCalculator={false} currency="eur" locale="fr" signupPath="/fr/signup" />
      <FAQFR variant="agents" />
      <FooterFR variant="agents" />
    </motion.div>
  );
};

export default PageFR;
